import React, { useState } from 'react';

const InputTextArea = ({ placeholder, onChange, ...rest }) => {
  const [height, setHeight] = useState(20);
  const onBlur = () => {
    setHeight(20);
  };
  const onFocus = () => {
    setHeight(120);
  };
  return (
    <textarea
      onBlur={onBlur}
      onFocus={onFocus}
      onChange={onChange}
      placeholder={placeholder}
      style={{ width: '100%', height: height, transition: '.5s', resize:"none", padding:10 }}
      {...rest}
    ></textarea>
  );
};

export default InputTextArea;
